import { render, staticRenderFns } from "./myCerificate.vue?vue&type=template&id=15eeabed&scoped=true&"
import script from "./myCerificate.vue?vue&type=script&lang=js&"
export * from "./myCerificate.vue?vue&type=script&lang=js&"
import style0 from "./myCerificate.vue?vue&type=style&index=0&id=15eeabed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eeabed",
  null
  
)

export default component.exports